/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Kampanie',
    CERTIFICATES: 'Certyfikaty',
    CHALLENGES: 'Wyzwania',
    CHAT: 'Czat',
    CLOSE: 'Zamknij',
    CLUB: 'Klub',
    COMMISSIONED_PRODUCTS: 'Produkty zlecone',
    COMMUNICATIONS: 'Komunikacja',
    CONFIRM: 'Potwierdzenie',
    COUNTERPART: 'Odpowiedniki',
    DASHBOARD: 'Panel sterowania',
    DESIGN_REQUESTS: 'Zamówienia dotyczące projektu',
    DETAILS: 'Informacje ogólne',
    EXTERNAL_APPLICATIONS: 'Aplikacje zewnętrzne',
    FOLLOWER_MESSAGES: 'Obserwujący wiadomości',
    GENERICS: 'Ogólne',
    LINKS: 'Linki',
    LIVE: 'Bezpośredni',
    LOGOUT: 'Wyjście',
    MEMBERS: 'Partnerzy',
    MENTIONS: 'Wzmianki',
    OFFERS: 'Oferty',
    ON_DEMAND_CAMPAIGNS: 'Kampanie na żądanie',
    OPPORTUNITIES: 'Możliwości',
    ORDERS: 'Opłacone zamówienia',
    PARTNERS: 'Partnerzy',
    PERSONAL_AREA: 'Obszar osobisty',
    PRODUCTS_OFFERED: 'Oferowane produkty',
    PROFILE: 'Profil',
    PROZIS_COMMUNITY: 'Społeczność Prozis',
    QUESTIONS: 'Pytania',
    REMUNERATIONS: 'Wynagrodzenie',
    SELECT_LANGUAGE: 'Wybierz język',
    SELECT_PARTNER: 'Wybór innego partnera',
    SERVICES: 'Usługi',
    SOCIAL_NETWORK: 'Sieć społecznościowa Prozis',
    STATISTICS: 'Statystyki',
    VIDEO_TUTORIALS: 'Samouczki wideo'
  },
  ERROR: {
    ERROR: 'Błąd',
    FETCH_DATA: 'Pobierz dane'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Kampanie',
    CHALLENGES: 'Wyzwania',
    CHAT: 'Czat',
    COMMUNICATIONS: 'Komunikacja',
    COUNTERPARTS: 'Odpowiedniki',
    DASHBOARD: 'Panel sterowania',
    DESIGN_REQUESTS: 'Zamówienia dotyczące projektu',
    DETAILS: 'Szczegóły',
    EXTERNAL_APPLICATIONS: 'Aplikacje zewnętrzne',
    FILTER: 'Filtr',
    FILTERED: 'Filtrowane',
    FOLLOWER_MESSAGES: 'Obserwujący wiadomości',
    GENERICS: 'Ogólne',
    HOME: 'Powrót',
    LINKS: 'Linki',
    LOGOUT: 'Wyjście',
    MEMBERS: 'Partnerzy',
    MENTIONS: 'Wzmianki na Instagramie',
    NOT_FOUND: '404, Zgubiłeś się?',
    OFFERS: 'Oferty',
    ORDERS: 'Zamawianie',
    PARTNERSHIP_NOT_FOUND: 'Nie znaleziono partnera.',
    PENDING_COUNTERPART: 'Oczekujące odpowiedniki z poprzedniego okresu',
    PENDING_COUNTERPART_CURRENT: 'Zaległe odpowiedniki za bieżący miesiąc',
    PENDING_REMUNERATION: 'Wynagrodzenie zaległe z poprzedniego okresu',
    PENDING_REMUNERATION_CURRENT: 'Zaległe płatności za bieżący miesiąc',
    PERSONAL_AREA: 'Obszar osobisty',
    PRODUCTS: 'Produkty',
    REMUNERATIONS: 'Wynagrodzenie',
    SEARCH_PARTNERSHIP: 'Szukam partnera',
    SELECT_LANGUAGE: 'Wybierz język',
    SELECT_PARTNERSHIP: 'Wybór partnera',
    UNAUTHROZIED: '403, Nieautoryzowany dostęp!!!'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
